export var COLORS = {
    white: '#fff',
    spot: {
        success: '#0EB075',
        warning: '#FFCC00',
        critical: '#FF3457'
    },
    starRating: {
        five: '#007F4E',
        four: '#73B143',
        three: '#F8CC18',
        two: '#F47324',
        one: '#E22027'
    },
    grays: {
        darkest: '#292929',
        dark: '#535353',
        gray: '#7E7E7E',
        light: '#A9A9A9',
        lighter: '#D4D4D4',
        lightest: '#F2F2F2',
        super: '#F8F8F8',
        cardBorder: '#DFE2E5',
        background: '#EFF3F6'
    },
    blues: {
        primary: '#368CD7',
        light: '#54A5E5',
        lighter: '#7CBEFA',
        lightest: '#A2D3FF'
    }
};
export var GRID = {
    xsmall: '8px',
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '40px',
    xxlarge: '80px'
};
export var PADDING = {
    tiny: '16px',
    small: '24px',
    default: '32px',
    big: '40px',
    huge: '80px'
};
export var margin = PADDING;
export var BORDER_RADIUS = {
    small: '3px',
    medium: '4px',
    large: '5px'
};
export var FONT = {
    family: 'Lato, sans-serif',
    sizes: {
        small: {
            fontSize: '12px',
            lineHeight: '16px'
        },
        regular: {
            fontSize: '14px',
            lineHeight: '20px'
        },
        large: {
            fontSize: '18px',
            lineHeight: '28px'
        },
        h1: {
            fontSize: 34,
            lineHeight: '48px'
        },
        h2: {
            fontSize: 26,
            lineHeight: '36px'
        },
        h3: {
            fontSize: 20,
            lineHeight: '28px'
        },
        h4: {
            fontSize: 18,
            lineHeight: '28px'
        },
        h5: {
            fontSize: 16,
            lineHeight: '24px'
        }
    },
    weight: {
        light: 300,
        regular: 400,
        bold: 700
    }
};
